export default __webpack_public_path__ + "static/media/Strangler's Leggings of the Grim Cabal.608bf735.jpg";